import { bucketsStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryBuckets";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

bucketsStyles.item = {
    ...bucketsStyles.item,

    css: css`
        ${TypographyStyle} {
            font-size: 14px;
            font-weight: normal;
            line-height: 1.71;
            letter-spacing: normal;

            &:first-child {
                font-weight: bold;
            }
        }
    `,
};
